/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { Wholesaler } from "./wholesaler";

export class UserLogin {
    userLogin_key: number;
    wholesaler_fk: number;
    wholesaler: Wholesaler;
    userName: string;
    password: string;
    fullName: string;
    description: string;
    loginType: string;
    appUserId: number;
}
